export function discountValue(price, discount = 0, isPercentage = 0) {
  if (!isPercentage) return -discount;

  return -(discount * price) / 100;
}
